import { TestIds as FillLayersTestIds } from '../../../FillLayers/constants';

export const TestIds = {
  audio: 'vb-audio',
  canvas: FillLayersTestIds.canvas,
};

// Values from Mon Feb 19 2018 16:32:26
export const imageOverlayPreviewMap: Record<string, string> = {
  '0da768_29efdf1bc5e64eab8ac3ffabfe1c9baa~mv2.gif':
    '0da768_7d60c0c396ae49fea6cd91d02e5fca48~mv2.gif',
  '0da768_87c0449843044d08959716658a645c96~mv2.gif':
    '0da768_ea0310bcbd8441899d15002a9d876b12~mv2.gif',
  '0da768_b3ab524ad67a4d6faa3f396c00970923~mv2.gif':
    '0da768_c1cfb0ff807248afb557469ca635473c~mv2.gif',
  '0da768_475b86e3dc6241e290cea0ac998aeaa5~mv2.gif':
    '0da768_54ef3fc08a4249f5971fb09307194ddb~mv2.gif',
  '0da768_56322380170745d489451031cab1165b~mv2.gif':
    '0da768_98074997bf884ccf95471883f3b76002~mv2.gif',
  '0da768_53d425a0833f4928877dc3ad48cfa9ed~mv2.gif':
    '0da768_4dc1994ccd634c05bd2aa0ecf28f554d~mv2.gif',
  '0da768_bdc34b5849b94a098930986501c8495e~mv2.gif':
    '0da768_aeef7adcda534ac9859e8436ceb3b8f4~mv2.gif',
  '0da768_8ea07e1913bf4427927b033a4382fa02~mv2.gif':
    '0da768_1060aa46d6814575a0510c8fb1ed9ba5~mv2.gif',
  '0da768_a75a21a0466d492f8dc752e754d64150~mv2.gif':
    '0da768_e94416bc369f4de19c20e502abe2afae~mv2.gif',
  '0da768_382f68fae4a245adb30a77b0c8e60482~mv2.gif':
    '0da768_767ec5e180b443deafb57943a9172a8d~mv2.gif',
  '0da768_93a7492350884b349996b3de50c1a344~mv2.gif':
    '0da768_c105d4cd31db472e923f39eba82884d0~mv2.gif',
  '0da768_5c2fa8e77e5f4a30904b62397e86b009~mv2.gif':
    '0da768_e2a082ea63c04891a9cdf2b5ff4b3685~mv2.gif',
  '0da768_e6dabf0c7b334a4c826f6a4c90bc68f1~mv2.gif':
    '0da768_a8d3951f1fff4571bd07bc387d8fbf2f~mv2.gif',
  '0da768_1254d39cf4e04b61a470a5ebc453d6c8~mv2.gif':
    '0da768_ab65ce6648e446a994df3cd655d023de~mv2.gif',
  '0da768_6d3e07f0ef6b4036a8393ed7f3123537~mv2.gif':
    '0da768_42567846cab8490e863927c0be50cf7f~mv2.gif',
  '0da768_d563ebc4d83b4f94a4804805fef13e9e~mv2.gif':
    '0da768_88cd0d5cb35e49ed852147004ee7a948~mv2.gif',
  '0da768_ec704140a9a0404ba0462af12e0096f7~mv2.gif':
    '0da768_9e0460e1534248f8aafe78295fe733d2~mv2.gif',
  '0da768_6ea8a6bdd07f4e7cbbe051bb919336e7~mv2.gif':
    '0da768_9b144cd87ac940b58542dd5481e26f85~mv2.gif',
  '0da768_faaa3147bff547ecab15d93e3fd29a99~mv2.gif':
    '0da768_43b6e29ed76548959a87d57361cadd6d~mv2.gif',
};

export const ARIA_LABEL_NAMESPACE = 'ariaLabels';
export const VIDEOBOX_PLAY_ARIA_LABEL_KEY = 'VideoBox_AriaLabel_Play_Video';
export const VIDEOBOX_PLAY_ARIA_LABEL_DEFAULT = 'Play video';
